function getEntity(db, storeName) {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readonly');
    const dataStream = tx.objectStore(storeName).getAll();
    dataStream.onsuccess = (event) => {
      resolve(event.target.result);
    };
    dataStream.onerror = reject;
  });
}

export default function get(userId) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(`search_history_${userId}`, 1);

    request.onsuccess = async (e) => {
      const db = e.target.result;
      const entityNames = ['customers', 'queries', 'companies', 'posts', 'events'];
      const promises = entityNames.map(name => getEntity(db, name));

      try {
        const data = await Promise.all(promises);
        const result = data.reduce((accum, item, index) => {
          const key = entityNames[index];
          // eslint-disable-next-line no-param-reassign
          accum[key] = item;
          return accum;
        }, {});
        resolve(result);
      } catch (err) {
        reject(err);
      }
    };
  });
}
